import { faIcons } from "@app/shared/library/fa-icons";
import { MenuItem } from "@app/shared/models/menu-item";

export const menuItemsCem: MenuItem[] = [
  {
    "state": "projects",
    "name": "Projects",
    "type": "sub",
    "icon": faIcons.clipboard,
    "liveScenarioOnly": true,
    "children": [
      {
        "state": "home",
        "name": "Home",
        "type": "link",
        "security": ["Admin", "Projects"]
      }
    ]
  },
  {
    "state": "projects",
    "name": "Items",
    "type": "sub",
    "icon": faIcons.list,
    "liveScenarioOnly": true,
    "children": [
      {
        "state": "items",
        "name": "Items",
        "type": "link",
        "security": ["Admin", "Projects"]
      }
    ]
  },
  {
    "state": "projects",
    "name": "Scoping Items",
    "type": "sub",
    "icon": faIcons.layers,
    "liveScenarioOnly": true,
    "children": [
      {
        "state": "scoping-items",
        "name": "Scoping Items",
        "type": "link",
        "security": ["Admin", "Projects"]
      }
    ]
  },
  {
    "state": "projects",
    "name": "Standard Configs",
    "type": "sub",
    "icon": faIcons.moneyCheck,
    "liveScenarioOnly": true,
    "children": [
      {
        "state": "standard-configs",
        "name": "Standard Configs",
        "type": "link",
        "security": ["Admin", "Projects"]
      }
    ]
  },
  {
    "state": "projects",
    "name": "Depths",
    "type": "sub",
    "icon": faIcons.toolbox,
    "liveScenarioOnly": true,
    "children": [
      {
        "state": "formation-top",
        "name": "Formation Tops",
        "type": "link",
        "security": ["Admin", "Projects"]
      }
    ]
  },
  {
    "state": "admin",
    "name": "Equation Manager",
    "type": "sub",
    "icon": faIcons.tablet,
    "children": [
      {
        "state": "equation-manager",
        "name": "Equation Manager",
        "type": "link",
        "security": ["Admin", "Projects"]
      }
    ]
  },
  {
    "state": "projects",
    "name": "Wells",
    "type": "sub",
    "icon": faIcons.oilWell,
    "liveScenarioOnly": true,
    "children": [
      {
        "state": "wells",
        "name": "Wells",
        "type": "link",
        "security": ["Admin", "Projects"]
      }
    ]
  },
  {
    "state": "admin",
    "name": "Admin",
    "type": "sub",
    "icon": faIcons.userCircle,
    "children": [
      {
        "state": "standard-configurations",
        "name": "Standard Configurations",
        "type": "link",
        "security": ["Admin"]
      }
    ]
  }
];
